module.exports = __webpack_public_path__ + "r-v3/img/ico_room_url_copy_white.23b20f99.svg";